import React from "react";
import Banner from "../components/location/banner";
import LocatonCard from "../components/location/location-card";
import Places from "../components/location/places";
import LocationMap from "../components/location/location-map";

function Location() {
  return (
    <>
      <Banner />
      <LocatonCard />
      <Places />
      <LocationMap />
    </>
  );
}

export default Location;
